export const GB_DASHBOARD_URL =
  (import.meta.env.VITE_WIX_APP_GB_DASHBOARD_URL as string | undefined) ??
  'https://dashboard.givebutter.com';
